var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityCritical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5937 10.371C16.3888 10.6988 15.9569 10.7985 15.6291 10.5936L12.0001 8.32546L8.37107 10.5936C8.04323 10.7985 7.61136 10.6988 7.40647 10.371C7.20157 10.0432 7.30123 9.61129 7.62907 9.40639L11.6291 6.90639C11.8561 6.76452 12.1441 6.76452 12.3711 6.90639L16.3711 9.40639C16.6989 9.61129 16.7986 10.0432 16.5937 10.371ZM16.5937 13.371C16.3888 13.6988 15.9569 13.7985 15.6291 13.5936L12.0001 11.3255L8.37107 13.5936C8.04323 13.7985 7.61136 13.6988 7.40647 13.371C7.20157 13.0432 7.30123 12.6113 7.62907 12.4064L11.6291 9.90639C11.8561 9.76452 12.1441 9.76452 12.3711 9.90639L16.3711 12.4064C16.6989 12.6113 16.7986 13.0432 16.5937 13.371ZM15.6291 16.5936C15.9569 16.7985 16.3888 16.6988 16.5937 16.371C16.7986 16.0432 16.6989 15.6113 16.3711 15.4064L12.3711 12.9064C12.1441 12.7645 11.8561 12.7645 11.6291 12.9064L7.62907 15.4064C7.30123 15.6113 7.20157 16.0432 7.40647 16.371C7.61136 16.6988 8.04323 16.7985 8.37107 16.5936L12.0001 14.3255L15.6291 16.5936Z",
    fill: "#FF3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityCritical);
export default __webpack_public_path__ + "static/media/priority-critical.ff933316765f0846f4a61669a929f4ab.svg";
export { ForwardRef as ReactComponent };